import { normalizeCityName } from "@utils/urlNormalization";
import { toKebabCase } from "@utils/stringFormatters";

const PRICE_PAGE_PATH_REGEX = /^\/cars\/([^/]+)\/price-in-([^/]+)\/?$/;
const TRAILING_YEAR_SEGMENTS_REGEX = /(?:-20\d{2})+$/;

export interface PricePagePathParts {
  slug: string;
  citySlug: string;
}

export interface BuildPricePageCanonicalPathnameParams extends PricePagePathParts {
  makeName?: string;
  modelName?: string;
}

export const parsePricePagePathname = (
  pathname: string
): PricePagePathParts | null => {
  const match = pathname.match(PRICE_PAGE_PATH_REGEX);

  if (!match) {
    return null;
  }

  const [, slug, citySlug] = match;

  return {
    slug,
    citySlug,
  };
};

export const getCanonicalModelSlug = (
  makeName?: string,
  modelName?: string,
  fallbackSlug = ""
): string => {
  const makeSlug = toKebabCase(makeName);
  const modelSlug = toKebabCase(modelName);

  if (makeSlug && modelSlug) {
    return stripTrailingYearSegments(`${makeSlug}-${modelSlug}`);
  }

  return stripTrailingYearSegments(toKebabCase(fallbackSlug));
};

export const stripTrailingYearSegments = (slug: string): string => {
  return slug.replace(TRAILING_YEAR_SEGMENTS_REGEX, "");
};

export const buildPricePageCanonicalPathname = ({
  slug,
  citySlug,
  makeName,
  modelName,
}: BuildPricePageCanonicalPathnameParams): string => {
  const canonicalSlug = getCanonicalModelSlug(makeName, modelName, slug);
  const normalizedCitySlug = normalizeCityName(citySlug);

  return `/cars/${canonicalSlug}/price-in-${normalizedCitySlug}/`;
};
